import TableEmptyState from './TableEmptyState';
export default TableEmptyState;
